export class NoResultsError extends Error {}

export const fetchStructures = async (taId, searchValue, page) => {
  const url = window.imaiosRouting.getFosJsRoutingUrlWithSiteaccess(
    'rest_api_anatomy_treeview_search_by_taid',
    {
      'taid': encodeURIComponent(taId),
      'text': encodeURIComponent(searchValue),
      'page': page
    }
  );

  const response = await window.imaios.fetch(url, {
    method: 'GET',
    headers: new Headers({ 'X-Requested-With': 'XMLHttpRequest' })
  });

  if (response.status >= 400 || response.redirected === true) {
    throw new Error(
      `Tree view search error with http code '${response.status}'`
    );
  }

  if (response.status === 204) {
    throw new NoResultsError();
  }

  if (response.status !== 200) {
    throw new Error(
      `Unexpected response http code '${response.status}' on tree view search for url '${url}'.`
    );
  }

  return await response.json();
};

export const fetchSuggestions = async (taId, searchValue, page) => {
  const url = window.imaiosRouting.getFosJsRoutingUrlWithSiteaccess(
    'rest_api_anatomy_treeview_search_by_taid_with_suggestions',
    {
      'taid': encodeURIComponent(taId),
      'text': encodeURIComponent(searchValue),
      'page': page
    }
  );

  const response = await window.imaios.fetch(url, {
    method: 'GET',
    headers: new Headers({ 'X-Requested-With': 'XMLHttpRequest' })
  });

  if (response.status >= 400 || response.redirected === true) {
    throw new Error(
      `Tree view search suggestions error with http code '${response.status}'`
    );
  }

  if (response.status === 204) {
    throw new NoResultsError();
  }

  if (response.status !== 200) {
    throw new Error(
      `Unexpected response http code '${response.status}' on tree view search suggestions for url '${url}'.`
    );
  }

  return await response.json();
};
